import React from 'react';
import { TrendingUp, Euro, PenLine, Clock } from 'lucide-react';

/**
 * Devis page — top KPI cards (Pipeline / Signé / Acceptance / Avg delay).
 * Pure presentational — receives the `kpis` payload from `/analytics/quotes-kpis`.
 */
export default function DevisKPICards({ kpis }) {
  const items = [
    { label: 'Pipeline (non signé)', value: `${(kpis?.pipeline_amount || 0).toLocaleString('fr-FR')} €`, color: '#4F46E5', icon: Euro },
    { label: 'Signé / Converti', value: `${(kpis?.accepted_amount || 0).toLocaleString('fr-FR')} €`, color: '#14B8A6', icon: TrendingUp },
    { label: 'Taux d\u2019acceptation', value: `${kpis?.acceptance_rate || 0}%`, color: '#F59E0B', icon: PenLine },
    { label: 'Délai moyen signature', value: kpis?.avg_conversion_days ? `${kpis.avg_conversion_days} j` : '—', color: '#3B82F6', icon: Clock },
  ];
  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4" data-testid="devis-kpi-cards">
      {items.map((s) => (
        <div key={s.label} className="soft-card p-4">
          <div className="flex items-center justify-between">
            <div className="text-[12px] text-[#8E8FA5] font-medium">{s.label}</div>
            <s.icon className="w-4 h-4" style={{ color: s.color }} />
          </div>
          <div className="text-[22px] font-bold mt-0.5" style={{ color: s.color, fontFamily: "'Plus Jakarta Sans', sans-serif" }}>{s.value}</div>
        </div>
      ))}
    </div>
  );
}
